(function() {
    if(document.getElementById("af-kununu-rating-intro")) {
        //Toggler
        const afKununuWidgetToggler = document.getElementById("af-kununu-rating-intro");
        //Toggle kununu widget
        function afToggleKununWidget() {
            const afKununuWidget = document.getElementById("af-kununu-rating-widget");
            afKununuWidget.className = afKununuWidget.className === "af-kununu-rating-widget-expanded" ? "" : "af-kununu-rating-widget-expanded";
        }
        afKununuWidgetToggler.addEventListener("click",afToggleKununWidget);
    }
})();
